import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('❌ ErrorBoundary caught error:', error);
    console.error('❌ Error info:', errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '50px',
          background: 'orange',
          minHeight: '100vh'
        }}>
          <h1 style={{fontSize: '48px', color: 'red'}}>
            ⚠️ FEJL FANGET AV ERROR BOUNDARY
          </h1>
          <h2 style={{fontSize: '24px', color: 'darkred'}}>
            {this.state.error?.toString()}
          </h2>
          <pre style={{
            background: 'white',
            padding: '20px',
            fontSize: '14px',
            overflow: 'auto'
          }}>
            {this.state.errorInfo?.componentStack}
          </pre>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
